import { handleActions } from 'redux-actions'
import { getLocalItem } from '../../utils'
import { BotSet } from '../../model/bot.model'
import { Set_Bot_Settings } from '../actions/bot'

export const Local_User_Key = 'l_bot_st'

/** 用户信息初始化 */
const initSettingsInfo = (): BotSet | null => {
    return getLocalItem(Local_User_Key)
}

const botReducer = handleActions(
    {
        /** 获取机器人设置 */
        [Set_Bot_Settings]: (state, { payload }) => {
            // console.log('Set_Bot_Settings', payload)
            return payload
        },
    },
    initSettingsInfo()
)

export default botReducer
